/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
import { useUnstyled as d, classNames as n, uDropDownsBase as l } from "@progress/kendo-react-common";
import * as u from "react";
const v = (t) => {
  const { group: c, virtual: o, render: e, isMultiColumn: s = !1, id: m } = t, r = d(), i = r && r.uDropDownsBase, a = /* @__PURE__ */ u.createElement(
    "li",
    {
      id: m,
      role: "group",
      className: n(l.groupLi({ c: i, isMultiColumn: s })),
      style: s ? { boxSizing: "inherit", position: o ? "relative" : "unset" } : { position: o ? "relative" : "unset" }
    },
    /* @__PURE__ */ u.createElement(
      "span",
      {
        className: e ? void 0 : n(l.groupItemText({ c: i, isMultiColumn: s }))
      },
      c
    )
  );
  return e !== void 0 ? e.call(void 0, a, t) : a;
};
export {
  v as default
};
